import React from "react";
import { Globe, MapPin, GitMerge } from "lucide-react";

// PROMPT 3 — Global / Local / Hybrid control badge.
//   global : applies everywhere; Super Admin controls it.
//   local  : applies only to this territory/sub-site; approved local admins edit it.
//   hybrid : local can draft, but Super Admin must approve before publishing.
const KINDS = {
  global: {
    label: "Global",
    icon: Globe,
    style: { backgroundColor: "rgba(28,67,88,0.10)", color: "#1C4358", borderColor: "rgba(28,67,88,0.22)" },
    tip: "Global — applies everywhere. Super Admin controls it.",
  },
  local: {
    label: "Local",
    icon: MapPin,
    style: { backgroundColor: "rgba(47,125,90,0.12)", color: "#2F7D5A", borderColor: "rgba(47,125,90,0.24)" },
    tip: "Local — applies only to this territory/sub-site. Approved local admins can edit it.",
  },
  hybrid: {
    label: "Hybrid",
    icon: GitMerge,
    style: { backgroundColor: "rgba(183,121,31,0.14)", color: "#B7791F", borderColor: "rgba(183,121,31,0.28)" },
    tip: "Hybrid — local can draft, but Super Admin must approve before publishing.",
  },
};

export const ControlBadge = ({ kind = "global", label, className = "" }) => {
  const k = KINDS[kind] || KINDS.global;
  const Icon = k.icon;
  return (
    <span
      title={k.tip}
      aria-label={k.tip}
      data-testid={`control-badge-${kind}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${className}`}
      style={k.style}
    >
      <Icon size={11} />
      {label || k.label}
    </span>
  );
};

export const CONTROL_KIND_TIP = (kind) => (KINDS[kind] || KINDS.global).tip;

export default ControlBadge;
